/**
 * The app's icons, drawn with the IcoMoon icon font (assets/styles/vendors/icomoon), the default icon font of the
 * UI. Each name maps to an IcoMoon glyph class (`icon-<glyph>`).
 */
export const glyphs = {
  menu: 'menu',
  dashboard: 'chart',
  tasks: 'clipboard6',
  projects: 'drawer3',
  analytics: 'stats-bars',
  calendar: 'calendar',
  team: 'users',
  reports: 'file-text2',
  messages: 'bubble-lines3',
  settings: 'cog',
  help: 'question',
  logout: 'exit',
  search: 'search',
  bell: 'bell',
  chevronDown: 'arrow-down5',
  chevronLeft: 'arrow-left5',
  chevronRight: 'arrow-right5',
  eye: 'eye',
  eyeOff: 'eye-blocked',
  plus: 'plus-circle',
  plusCircle: 'plus-circle',
  fileExcel: 'file-excel',
  fileCsv: 'file-spreadsheet',
  filePdf: 'file-pdf',
  stopwatch: 'stopwatch',
  money: 'coin-dollar',
  today: 'calendar-day',
  location: 'location',
  archive: 'box-add',
  unarchive: 'box-remove',
  prev: 'arrow-left8',
  next: 'arrow-right8',
  check: 'checkmark',
  clock: 'clock',
  close: 'cancel-circle',
  download: 'download',
  filter: 'filter',
  flag: 'flag',
  comment: 'bubble',
  attach: 'attachment',
  done: 'checkmark-circle',
  warning: 'warning',
  userPlus: 'user-plus',
  send: 'paperplane',
  play: 'play3',
  pause: 'pause2',
  edit: 'pencil',
  trash: 'bin',
  building: 'office',
  move: 'arrow-right16',
  arrowUp: 'arrow-up',
  arrowDown: 'arrow-down',
  user: 'user',
  mail: 'envelop',
  shield: 'shield',
  receipt: 'file-text',
  globe: 'earth',
  inbox: 'drawer',
  // header set (after the organisation's reference header)
  bellRing: 'bell2',
  caret: 'arrow-down2',
  profile: 'user',
  signOut: 'switch'
} as const;

export type IconName = keyof typeof glyphs;
